import React, { PureComponent } from 'react';

// Components
import { Spin, Modal, Row, Col } from 'antd';

// Constants
import { MODAL_SIZES } from '../../../constants/modal';

class MqttAccessApiModal extends PureComponent {

    render() {
        const {
            isShown,
            isLoading,
            msgs,
            onCancel,
            content
        } = this.props;
        return (
            <Modal
                key="modal-mqtt-access-api"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.LARGE}
                title="Mqtt Access API"
                onCancel={onCancel}
                cancelText={msgs.close}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <Spin spinning={isLoading} size="large">
                    <Row gutter={8}>
                        <Col xs={24}>
                            {
                                content.split('\n').map(item => <span key={`item-${item.split('=')[0]}`}>{item}<br /></span>)
                            }
                        </Col>
                    </Row>
                </Spin>
            </Modal>
        );
    }
}

export default MqttAccessApiModal;
